import React from "react";

import Skeleton, { SkeletonCircle } from "src/app/components/Skeleton/Skeleton";
import { tableDataType } from "src/app/components/Table/Table";

interface GlobalFieldsSkeletonProps {
  dataType?: tableDataType;
  enableFieldManaging?: boolean;
}

const SKELETON_ROWS = [
  { id: "skeleton-row-1", nameWidth: "48%", descriptionWidth: "82%" },
  { id: "skeleton-row-2", nameWidth: "62%", descriptionWidth: "55%" },
  { id: "skeleton-row-3", nameWidth: "38%", descriptionWidth: "72%" },
  { id: "skeleton-row-4", nameWidth: "56%", descriptionWidth: "90%" },
  { id: "skeleton-row-5", nameWidth: "44%", descriptionWidth: "64%" },
  { id: "skeleton-row-6", nameWidth: "58%", descriptionWidth: "78%" },
];

export default function GlobalFieldsSkeleton({
  dataType,
  enableFieldManaging,
}: GlobalFieldsSkeletonProps) {
  return (
    <ul className="global-fields__list">
      {SKELETON_ROWS.map(({ id, nameWidth, descriptionWidth }) => (
        <li
          key={id}
          className="global-fields__list-item global-fields__list-item--skeleton"
        >
          {enableFieldManaging && (
            <span className="global-fields__list-item-drag">
              <Skeleton variant="text" width={16} height={16} />
            </span>
          )}
          <div className="global-fields__text">
            <Skeleton variant="text" width={nameWidth} height={14} />
            <Skeleton
              variant="text"
              width={descriptionWidth}
              height={10}
              marginTop={8}
            />
          </div>
          {enableFieldManaging && (
            <div className="global-fields__used">
              <SkeletonCircle size={20} />
            </div>
          )}
          {dataType === tableDataType.Task && (
            <div className="global-fields__applicable-for">
              <Skeleton variant="text" width={56} height={12} />
            </div>
          )}
          <div className="global-fields__icon">
            <Skeleton variant="text" width={24} height={24} />
          </div>
          {enableFieldManaging && dataType && (
            <div className="global-fields__action">
              <Skeleton variant="text" width={24} height={24} />
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
